import { render, staticRenderFns } from "./workflowList.vue?vue&type=template&id=2aa342ae&"
import script from "./workflowList.vue?vue&type=script&lang=js&"
export * from "./workflowList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports